<div class="modal-header">
    Promemoria
</div>
<div class="modal-body">
    <div class="mb-3 text-center" *ngIf="closeTimeoutId">
        <small>Chiude automaticamente in {{ remainingSeconds }} secondi</small>
    </div>
    <table class="table table-nowrap table-sm table-striped m-0 text-sm">
        <thead>
            <th>Descrizione</th>
            <th class="text-center">Ricorda ancora?</th>
        </thead>
        <tbody>
            <tr *ngFor="let r of list">
                <td>{{r.description}}</td>
                <td class="text-center">
                    <div class="btn-group btn-group-sm" role="group">
                        <button type="button" class="btn btn-sm btn-primary" [class.active]="r.state==1" (click)="changeState(r,1)">Sì</button>
                        <button type="button" class="btn btn-sm btn-danger" [class.active]="r.state==2" (click)="changeState(r,2)">No</button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>   
</div>
<div class="modal-footer">
    <button class="btn btn-secondary btn-sm" (click)="close()"><i class="fas fa-times mr-1"></i>Chiudi</button>
</div>